import { gql } from '@apollo/client';

export const FINANCIAL_INDICATOR_DELETED = gql`
  subscription financialIndicatorDeleted {
    financialIndicatorDeleted {
      financialIndicatorId
    }
  }
`;
